import { apiUrl } from '../config/api'

// Orders API client
// Backend base: /api/orders

export async function listOrders() {
  const res = await fetch(apiUrl('/api/orders'), {
    headers: { 'Accept': 'application/json' },
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function getOrder(id) {
  const res = await fetch(apiUrl(`/api/orders/${id}`), {
    headers: { 'Accept': 'application/json' },
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function createOrder(payload, token) {
  const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' }
  if (token) headers['Authorization'] = `Bearer ${token}`

  const res = await fetch(apiUrl('/api/orders'), {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateOrder(id, payload) {
  const res = await fetch(apiUrl(`/api/orders/${id}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

// ----- Suborders -----
export async function addSubOrder(orderId, payload) {
  const res = await fetch(apiUrl(`/api/orders/${orderId}/suborders`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateSubOrder(orderId, subId, payload) {
  const res = await fetch(apiUrl(`/api/orders/${orderId}/suborders/${subId}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function deleteSubOrder(orderId, subId) {
  const res = await fetch(apiUrl(`/api/orders/${orderId}/suborders/${subId}`), {
    method: 'DELETE',
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return true
}

// ----- Items under suborders -----
export async function addSubOrderItem(orderId, subId, payload) {
  const res = await fetch(apiUrl(`/api/orders/${orderId}/suborders/${subId}/items`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateSubOrderItem(orderId, subId, itemId, payload) {
  const res = await fetch(apiUrl(`/api/orders/${orderId}/suborders/${subId}/items/${itemId}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function deleteSubOrderItem(orderId, subId, itemId) {
  const res = await fetch(apiUrl(`/api/orders/${orderId}/suborders/${subId}/items/${itemId}`), {
    method: 'DELETE',
    headers: { 'Accept': 'application/json' },
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return true
}
